module.exports = __webpack_public_path__ + "static/media/katolik_logo.c0133f17.png";